import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';

export interface AddDashboardNoteParams {
    readonly content: string;
}

export type AddDashboardNoteResponse = {
    value: number,
    version: string,
};

export class AddDashboardNoteCommand extends Command<AddDashboardNoteParams, AddDashboardNoteResponse> { }

export class AddDashboardNoteCommandHandlerBase implements CommandHandler<AddDashboardNoteCommand, AddDashboardNoteParams, AddDashboardNoteResponse> {
    private static Url = TaggedUrl.join('user/notes', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(cmd: AddDashboardNoteCommand): Promise<AddDashboardNoteResponse> {
        const { data } = await this.http.post(AddDashboardNoteCommandHandlerBase.Url, { content: cmd.params?.content });
        return data;
    }
}
